import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getCurrentUser } from '../services/telegram-auth';

/**
 * Хук для перенаправления авторизованных пользователей с главной страницы на страницу оборудования
 */
const useAuthRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Проверяем, авторизован ли пользователь
    const user = getCurrentUser();
    
    // Если пользователь авторизован и находится на главной странице,
    // перенаправляем его на страницу с оборудованием
    if (user && location.pathname === '/') {
      navigate('/equipment', { replace: true });
    }
  }, [navigate, location.pathname]);
};

export default useAuthRedirect; 